<digital-assets-sprite-svg></digital-assets-sprite-svg>
<dialog-close-icon-svg/>
<download-icon-svg />

<div class="row main-dialog-layout">

  <div class="col-lg-12 col-md-12 col-sm-12 col-12 close-btn-div">
    <a class="close-btn" (click)="close()">
      <svg class="close-btn-icon">
        <use xlink:href="#dialogCloseIcon"></use>
      </svg>
    </a>
  </div>

  <!-- Special simplified view for SCORM courses (exactly like the image) -->
  @if (data.isScormCourse) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 simple-message" style="text-align: center; margin-bottom: 20px; padding: 0 20px;">
        <span style="color: #485465; font-size: 16px; font-weight: 500;">
          Complete this course, and get access to all these assets.
        </span>
      </div>
    </div>
  }

  <!-- Original views for non-SCORM courses -->
  @if (!data.isScormCourse && data.lessonsWatched?.length != data.lessons?.length) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 lesson-not-completed"
      >
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 spinner-div">
        <div class="main-cert-spinner">
          <span style="display: none;"
          #mainavgnumber>{{FloatToRoundNum((convertStringToInt(data.lessonsWatched?.length))/(convertStringToInt(data.lessons?.length))*100)}}</span>
          @if (data.lessonsWatched?.length == 0) {
            <div class="main-cert-empty-spinner"></div>
          }
          @if (data.lessonsWatched?.length == data.lessons?.length) {
            <div class="main-cert-full-spinner"></div>
          }
          @if (data.lessonsWatched?.length != 0 && data.lessonsWatched?.length != data.lessons?.length) {
            <div class="cert-progress-indicator-container"
              >
              @if (data.lessonsWatched?.length != 0 && data.lessonsWatched?.length != data.lessons?.length) {
                <div class="main-cert-avg-spinner"
                  >
                </div>
              }
              @if (data.lessonsWatched?.length != 0 && data.lessonsWatched?.length != data.lessons?.length) {
                <mat-progress-spinner class="cert-progress-indicator cert-progress-circle"
                  mode="determinate" diameter="70" strokeWidth="6" value={{mainavgnumber.textContent}}>
                </mat-progress-spinner>
              }
            </div>
          }
          <span
          class="main-cert-indicate-text">{{FloatToRoundNum((convertStringToInt(data.lessonsWatched?.length))/(convertStringToInt(data.lessons?.length))*100)}}%</span>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 head-title-div">
        <span class="head-title-text">
          {{ 'watch.digitalAssetsDialog.completedCourse' | translate:{ completedCourseAvg:
          FloatToRoundNum((convertStringToInt(data.lessonsWatched?.length))/(convertStringToInt(data.lessons?.length))*100)
          } }}
        </span>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 sub-title-div">
        <span class="sub-title-text">
          {{ ("watch.digitalAssetsDialog.completedCourseNote" | translate) }}
        </span>
      </div>
    </div>
  }

  @if (!data.isScormCourse && data.lessonsWatched?.length == data.lessons?.length) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 lesson-completed"
      >
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 cert-success-head">
        <span class="cert-success-head-text">
          {{ ("watch.digitalAssetsDialog.congratulations" | translate) }}
        </span>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 cert-success-sub">
        <span class="cert-success-sub-text">
          {{ ("watch.digitalAssetsDialog.allCompletedCourse" | translate) }}
        </span>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 cert-success-preview-div">
      <div class="cert-success-preview" [ngStyle]="{'background-image': 'url(' + certificateimgurl + ')',
      'background-size': '100% 100%',
      'background-position': 'center', 'background-repeat': 'no-repeat', 'background-color': '#FFFFFF' }">
          <div class="cert-success-preview-title">{{ ("watch.digitalAssetsDialog.certificateCourseTitle" | translate) }}
          </div>
          <div class="cert-success-preview-title-text">{{course?.certificate?.customTitle ? course.certificate.customTitle
          :course.title}}</div>
        </div>
      </div>
    </div>
  }

  <!-- Certificate tiles - shown for all course types -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 row tiles-group-div">
    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pdf-tile tiles">
      <div class="tile-icon-div">
        <svg class="tile-icon">
          <use xlink:href="#certPdf"></use>
        </svg>
      </div>
      <div class="tile-text-div">
        <div class="tile-head-text">{{ ("watch.digitalAssetsDialog.certificatePdf" | translate) }}</div>
        <div class="tile-sub-text">{{ ("watch.digitalAssetsDialog.certificatePdfNote" | translate) }}</div>
      </div>
    </div>

    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 link-tile tiles">
      <div class="tile-icon-div">
        <svg class="tile-icon">
          <use xlink:href="#certLink"></use>
        </svg>
      </div>
      <div class="tile-text-div">
        <div class="tile-head-text">{{ ("watch.digitalAssetsDialog.certificateProofLink" | translate) }}</div>
        <div class="tile-sub-text">{{ ("watch.digitalAssetsDialog.certificateProofLinkNote" | translate) }}</div>
      </div>
    </div>

    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 html-tile tiles">
      <div class="tile-icon-div">
        <svg class="tile-icon">
          <use xlink:href="#certHtml"></use>
        </svg>
      </div>
      <div class="tile-text-div">
        <div class="tile-head-text">{{ ("watch.digitalAssetsDialog.certificateEmbeddableHTML" | translate) }}</div>
        <div class="tile-sub-text">{{ ("watch.digitalAssetsDialog.certificateEmbeddableHTMLNote" | translate) }}</div>
      </div>
    </div>

    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 linkedin-tile tiles">
      <div class="tile-icon-div">
        <svg class="tile-icon">
          <use xlink:href="#certLinkedIn"></use>
        </svg>
      </div>
      <div class="tile-text-div">
        <div class="tile-head-text">{{ ("watch.digitalAssetsDialog.certificateLinkedIn" | translate) }}</div>
        <div class="tile-sub-text">{{ ("watch.digitalAssetsDialog.certificateLinkedInNote" | translate) }}</div>
      </div>
    </div>
  </div>

  <!-- Button - different logic for SCORM vs regular courses -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 digital-assets-btn-div">
    <button class="digital-assets-btn" (click)="getCertificate()"
      [ngStyle]="{'background': (data.isScormCourse && data.hasCompletedCourse) || (!data.isScormCourse && data.lessonsWatched?.length == data.lessons?.length) ? data?.tenant?.brandTheme?.accentColor : '#AEBACA' }"
      [disabled]="(data.isScormCourse && !data.hasCompletedCourse) || (!data.isScormCourse && data.lessonsWatched?.length != data.lessons?.length)">
      <svg class="digital-assets-btn-icon">
        <use xlink:href="#downloadIcon"></use>
      </svg>
      <span class="digital-assets-btn-text">{{ ("watch.digitalAssetsDialog.getDigitalAssets" | translate) }}</span>
    </button>
  </div>

</div>
